import React, { useContext, useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import moment from "moment";
import RegistrationContext from "../../../context/registration/registrationContext";
import ProgressButtons from "../ProgressButtons";
import SubFormButtons from "../SubFormButtons";
import findBrand from "../../findBrand";
import { loadBrands } from "../../findBrand";
import states from "../../../data/states";
import countriesList from "../../../data/countriesList";
import phoneTypes from "../../../data/phoneTypes";
import gradeLevels from "../../../data/gradeLevels";
import { brandDomains } from "../../brand";

const R2StudentInformation = () => {
  const registrationContext = useContext(RegistrationContext);

  const {
    // onFormDataChange,
    getAge,
    subFormLevels,
    formData: {
      firstName,
      middleName,
      lastName,
      haveSuffix,
      suffix,
      gender,
      birthDate,
      age,
      schooldistrictofresidence,
      gradeLevel,
      birthState,
      studentEmail,
      birthCountry,
      studentPrimaryPhone,
      studentPrimaryPhoneType,
    },
    onFormDataChange,
    pass: { studentInformation },
  } = registrationContext;

  const [isLoading, setIsLoading] = useState(true);
  const [loadAttempts, setLoadAttempts] = useState(0);

  useEffect(() => {
    const initializeBrands = async () => {
      try {
        const success = await loadBrands();
        if (!success && loadAttempts < 3) {
          // Retry after a delay
          setTimeout(() => {
            setLoadAttempts(prev => prev + 1);
          }, 100);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Error loading brands:', error);
        if (loadAttempts < 3) {
          // Retry after a delay
          setTimeout(() => {
            setLoadAttempts(prev => prev + 1);
          }, 100);
        } else {
          setIsLoading(false);
        }
      }
    };

    initializeBrands();
  }, [loadAttempts]); // Re-run when loadAttempts changes

  if (isLoading) {
    return <div className="loading">Loading brand information...</div>;
  }

  // Check if brandDomains is available
  if (!brandDomains || Object.keys(brandDomains).length === 0) {
    return (
      <div className="error">
        <p>Error loading brand information.</p>
        <button onClick={() => setLoadAttempts(prev => prev + 1)}>
          Try Again
        </button>
      </div>
    );
  }

  const brand_holston = brandDomains?.brand_holston?.name;
  const brand_pbia = brandDomains?.brand_pbia?.name;
   
  // Birth date validation - returns true if age is INVALID (outside 4-50 range)
  const validateBirthday = () => {
    return age < 4 || age > 50;
  };

  // Check if birth date is valid (age between 4 and 50)
  const isBirthDateInvalid = birthDate && validateBirthday();
 
  const validateEmail = (email) => {
    const reg =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const re =
      /^[^.#]+([a-zA-Z[0-9.!$%&'*+/=?^_`{|}~-]+)[^-#\.]@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))+$/;
    ///^(+(\.[^<>()[a-zA-Z[0-9\]\\.,;:\s@"]+)*)|(".+")@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))+$/;
    return (
      re.test(String(email).toLowerCase()) &&
      reg.test(String(email).toLowerCase())
    );
  };

  const validatePhone = (number) => {
    const re = /^\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    return re.test(String(number).toLowerCase());
  };

  const formatPhoneNumber = (evt) => {
    const regex = /^\+?[0-9-]+$/;
    if (evt.target.value === "" || regex.test(evt.target.value)) {
      var aVal = evt.target.value;
      aVal = aVal
        .replace(/\\D/g, "")
        .replace(/ /g, "")
        .replace(/\-/g, "")
        .replace(/\(/g, "")
        .replace(/\)/g, "");
      if (aVal.length >= 10 && aVal.charAt(0) == "1")
        aVal = aVal.replace("-", "").replace("-", "");
      if (aVal.length > 0) {
        if (aVal.length > 8) {
          aVal =
            aVal.substring(0, 3) +
            "-" +
            aVal.substring(3, 6) +
            "-" +
            aVal.substring(6, 10);
          // window.alert(aVal);
          evt.target.value = aVal;
        } else if (aVal.length == 7) {
          aVal = aVal.substring(0, 3) + "-" + aVal.substring(3, 7);
          evt.target.value = aVal;
        }
      }
      onFormDataChange(evt);
    }
  };

  const intialFilledOut1 =
    (firstName !== "" &&
      lastName !== "" &&
      // haveSuffix !== "" &&
      gradeLevel !== "" &&
      // schooldistrictofresidence !== "" &&
      gender !== "" &&
      // birthState !== "" &&
      // birthCountry !== "" &&
      studentPrimaryPhone !== "" &&
      studentEmail !== "" &&
      validateEmail(studentEmail) &&
      studentPrimaryPhoneType !== "" &&
      validatePhone(studentPrimaryPhone) &&
      birthDate !== "" &&
      !validateBirthday(birthDate) &&
      age !== "" &&
    //   haveSuffix == "") ||
    // haveSuffix !== "";
    (haveSuffix === "" ||
      haveSuffix["no"] ||
      (haveSuffix["yes"] && suffix !== "")));

  const intialFilledOut2 =
    firstName !== "" &&
    lastName !== "" &&
    haveSuffix !== "" &&
    //suffix !== "" &&
    gender !== "" &&
    birthState !== "" &&
    birthCountry !== "" &&
    studentPrimaryPhone !== "" &&
    studentEmail !== "" &&
    validateEmail(studentEmail) &&
    studentPrimaryPhoneType !== "" &&
    validatePhone(studentPrimaryPhone) &&
    birthDate !== "" &&
    !validateBirthday(birthDate) &&
    (haveSuffix["no"] || (haveSuffix["yes"] && suffix !== ""));

 
  //findBrand is used to check whether holston forms or other forms
  if (findBrand(brand_holston) === true || findBrand(brand_pbia)===true) {
    return (
      <>
        <div className="sub-form">
          <h2>
            Student Information <span>(1/11)</span> <hr />
          </h2>

          <div className="item">
            <div className="asterisk-group">
              <h3>What is the Student's First Name?</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="firstName"
              maxLength="50"
              value={firstName}
              required
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : firstName !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Middle
                Name?
              </h3>
            </div>
            <input
              type="text"
              name="middleName"
              maxLength="50"
              onChange={(e) => onFormDataChange(e)}
              value={middleName}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Last
                Name?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="lastName"
              maxLength="50"
              required
              onChange={(e) => onFormDataChange(e)}
              value={lastName}
              style={{
                // textTransform: "capitalize",
                border: studentInformation
                  ? "2px solid #ccc;"
                  : lastName !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                Does {firstName === "" ? "the Student" : firstName} have a
                Suffix?
              </h3>
            </div>
            <div className="flex-check-container">
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={haveSuffix["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="haveSuffix"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={haveSuffix["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="haveSuffix"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>

          {haveSuffix["yes"] && (
            <div className="item">
              <div className="asterisk-group">
                <h3>
                  What is {firstName === "" ? "the Student" : firstName}'s
                  Suffix?
                </h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="suffix"
                maxLength="50"
                onChange={(e) => onFormDataChange(e)}
                value={suffix}
                style={{
                  border: studentInformation
                    ? "1px solid #ccc;"
                    : suffix !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              />
            </div>
          )}

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? " the Student" : firstName}'s
                Gender?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="gender"
              value={gender}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : gender !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select</option>
              <option value="Female">Female</option>
              <option value="Male">Male</option>
              <option value="Non-Binary">Non-Binary</option>
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s
                Birthdate?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="date"
              name="birthDate"
              max={moment().format("YYYY-MM-DD")}
              onChange={(e) => {
                onFormDataChange(e);
                getAge(moment(e.target.value).utc());
              }}
              value={birthDate}
              style={{
                border: studentInformation
                  ? "2px solid #ccc"
                  : (birthDate === "" || isBirthDateInvalid)
                  ? "2px solid #d8302f"
                  : "2px solid #ccc",
              }}
            />
            {/* Invalid age (less than 0 or more than 100) */}
            {birthDate && (age < 0 || age > 100) && (
              <p className="validEmail">Invalid age. Please enter a valid date of birth.</p>
            )}
            {/* Age less than 4 */}
            {birthDate && age >= 0 && age < 4 && (
              <p className="validEmail">Age must be at least 4 years.</p>
            )}
            {/* Age more than 50 */}
            {birthDate && age > 50 && age <= 100 && (
              <p className="validEmail">Age must be less than 50 years.</p>
            )}
            {/* No birth date */}
            {!studentInformation && !birthDate && (
              <p className="validEmail">Please provide a valid date of birth.</p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Grade
                Level?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            {/* <input
              type="text"
              name="gradeLevel"
              maxLength="50"
              required
              value={gradeLevel}
              onChange={(e) => handleChangeGradeLevel(e)}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : gradeLevel !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            /> */}

            <select
              name="gradeLevel"
              value={gradeLevel}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : gradeLevel !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {gradeLevels.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Email?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="email"
              name="studentEmail"
              value={studentEmail}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : studentEmail !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />

            {studentEmail !== "" && !validateEmail(studentEmail) && (
              <p className="validEmail">Please provide a valid email address</p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Primary
                Phone Number?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              placeholder="XXX-XXX-XXXX"
              name="studentPrimaryPhone"
              value={studentPrimaryPhone}
              onChange={(e) => formatPhoneNumber(e)}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : studentPrimaryPhone !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
            {studentPrimaryPhone !== "" &&
              !validatePhone(studentPrimaryPhone) && (
                <p className="validEmail">
                  Please provide a valid phone number in the following format
                  XXX-XXX-XXXX
                </p>
              )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Primary
                Phone Type?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="studentPrimaryPhoneType"
              value={studentPrimaryPhoneType}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : studentPrimaryPhoneType !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {phoneTypes.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>
        </div>
        <div className="group">{subFormLevels.studentInformation === 0}</div>
        <ProgressButtons
          validation={intialFilledOut1}
          name="studentInformation"
        />
      </>
    );
  } else {
    return (
      <>
        <div className="sub-form">
          <h2>
            Student Information <span>(1/15)</span> <hr />
          </h2>

          <div className="item">
            <div className="asterisk-group">
              <h3>What is the Student's First Name?</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="firstName"
              maxLength="50"
              value={firstName}
              required
              onChange={(e) =>  onFormDataChange(e)}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : firstName !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Middle
                Initial?
              </h3>
            </div>
            <input
              type="text"
              maxLength="50"
              name="middleName"
              onChange={(e) =>  onFormDataChange(e)}
              value={middleName}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Last
                Name?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="lastName"
              maxLength="50"
              required
              onChange={(e) =>  onFormDataChange(e)}
              value={lastName}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : lastName !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                Does {firstName === "" ? "the Student" : firstName} have a
                Suffix?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: studentInformation
                  ? "1px solid #ccc;"
                  : haveSuffix !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={haveSuffix["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="haveSuffix"
                  style={{
                    border: studentInformation
                      ? "1px solid #ccc;"
                      : haveSuffix !== ""
                      ? "1px solid #ccc"
                      : "#d8302f 2px solid",
                  }}
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={haveSuffix["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="haveSuffix"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>
          {haveSuffix["yes"] && (
            <div className="item">
              <div className="asterisk-group">
                <h3>
                  What is {firstName === "" ? "the Student" : firstName}'s
                  Suffix?
                </h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="suffix"
                maxLength="50"
                onChange={(e) =>  onFormDataChange(e)}
                value={suffix}
                style={{
                  border: studentInformation
                    ? "1px solid #ccc;"
                    : suffix !== ""
                    ? "1px solid #ccc"
                    : "#d8302f 2px solid",
                }}
              />
            </div>
          )}

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? " the Student" : firstName}'s
                Gender?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="gender"
              value={gender}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : gender !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select</option>
              <option value="Female">Female</option>
              <option value="Male">Male</option>
              <option value="Non-Binary">Non-Binary</option>
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Birth
                Date?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="date"
              name="birthDate"
              max={moment().format("YYYY-MM-DD")}
              onChange={(e) => {
                onFormDataChange(e);
                getAge(moment(e.target.value).utc());
              }}
              value={birthDate}
              style={{
                border: studentInformation
                  ? "2px solid #ccc"
                  : (birthDate === "" || isBirthDateInvalid)
                  ? "2px solid #d8302f"
                  : "2px solid #ccc",
              }}
            />
            {/* Invalid age (less than 0 or more than 100) */}
            {birthDate && (age < 0 || age > 100) && (
              <p className="validEmail">Invalid age. Please enter a valid date of birth.</p>
            )}
            {/* Age less than 4 */}
            {birthDate && age >= 0 && age < 4 && (
              <p className="validEmail">Age must be at least 4 years.</p>
            )}
            {/* Age more than 50 */}
            {birthDate && age > 50 && age <= 100 && (
              <p className="validEmail">Age must be less than 50 years.</p>
            )}
            {/* No birth date */}
            {!studentInformation && !birthDate && (
              <p className="validEmail">Please provide a valid date of birth.</p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Birth
                State?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="birthState"
              value={birthState}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : birthState !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select</option>
              {states.map((item) => {
                return (
                  <option value={Object.keys(item)}>{Object.keys(item)}</option>
                );
              })}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What Is {firstName === "" ? "the Student" : firstName}'s Birth
                Country?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="birthCountry"
              value={birthCountry}
              onChange={(e) =>  onFormDataChange(e)}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : birthCountry !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {countriesList.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Email?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="email"
              name="studentEmail"
              value={studentEmail}
              onChange={(e) => onFormDataChange(e)}
              style={{
                //  textTransform: "capitalize",
                border: studentInformation
                  ? "2px solid #ccc;"
                  : studentEmail !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
            {studentEmail !== "" && !validateEmail(studentEmail) && (
              <p className="validEmail">Please provide a valid email address</p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Primary
                Phone Number?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              placeholder="XXX-XXX-XXXX"
              name="studentPrimaryPhone"
              value={studentPrimaryPhone}
              onChange={(e) => formatPhoneNumber(e)}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : studentPrimaryPhone !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
            {studentPrimaryPhone !== "" &&
              !validatePhone(studentPrimaryPhone) && (
                <p className="validEmail">
                  Please provide a valid phone number in the following format
                  XXX-XXX-XXXX
                </p>
              )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Primary
                Phone Type?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="studentPrimaryPhoneType"
              value={studentPrimaryPhoneType}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: studentInformation
                  ? "2px solid #ccc;"
                  : studentPrimaryPhoneType !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {phoneTypes.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>
        </div>

        <div className="group">{subFormLevels.studentInformation === 0}</div>
        <ProgressButtons
          validation={intialFilledOut2}
          name="studentInformation"
        />
      </>
    );
  }
};

export default R2StudentInformation;
